import script from "./smartEssay.vue?vue&type=script&setup=true&lang=ts"
export * from "./smartEssay.vue?vue&type=script&setup=true&lang=ts"

import "./smartEssay.vue?vue&type=style&index=0&id=2f2fe152&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2fe152"]])

export default __exports__